import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getLocale, getUiDirection } from './helper/Locale';
import Grid from '@mui/material/Unstable_Grid2';
import { useDispatch, useSelector } from "react-redux";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { setTheme } from "./features/theme/themeSlice";
import { isEmbeddedInFrame } from './helper/FrameGuard';
import { getRecaptchaSiteKey } from './helper/runtimeConfig';

import './App.css';

import TrackForm from './components/TrackForm';
import LanguageSelector from './components/LanguageSelector';
import PoweredBy from './components/PoweredBy';
import EmbedRequired from './components/EmbedRequired';
import RecaptchaDisclosure from './components/RecaptchaDisclosure';

import '@fontsource/varela-round';
import '@fontsource-variable/open-sans';
import '@fontsource-variable/montserrat';

const RECAPTCHA_SCRIPT_PROPS = { async: true, defer: true };

function App() {
    const { i18n } = useTranslation();
    const { theme }  = useSelector((store) => store.theme)
    const dispatch = useDispatch();
    const uiDirection = getUiDirection();
    // Not useState: nothing ever updates this, and window.self/window.top
    // can't change during the lifetime of a loaded document, so there's no
    // reactive value to hold -- a plain call is clearer than an unused
    // state slot with no setter.
    const isEmbedded = isEmbeddedInFrame();

    useEffect(() => {
        i18n.changeLanguage(getLocale()).then(() => {
        }).catch(e => {
            console.error(e)
        });
    }, [i18n]);

    useEffect(() => {
        dispatch(setTheme());
    }, [dispatch]);

    if (!isEmbedded) {
        return <EmbedRequired direction={uiDirection} />;
    }

    const recaptchaSiteKey = getRecaptchaSiteKey();

    return (
        <div className="App" style={{ backgroundColor: theme.backgroundColor }}>
            <Grid container rowSpacing={0.5} columnSpacing={1} style={{ width: '100%' }} dir={uiDirection}>
                <Grid item xs={12} dir={uiDirection}>
                    {recaptchaSiteKey ? (
                        <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey} scriptProps={RECAPTCHA_SCRIPT_PROPS}>
                            <TrackForm />
                        </GoogleReCaptchaProvider>
                    ) : (
                        <TrackForm />
                    )}
                </Grid>
                <Grid item xs={6} dir={uiDirection}>
                    <LanguageSelector />
                </Grid>
                <Grid item xs={6} dir={uiDirection}>
                    <PoweredBy />
                </Grid>
                <Grid item xs={12} dir={uiDirection} style={{ paddingTop: 0 }}>
                    <RecaptchaDisclosure />
                </Grid>
            </Grid>
        </div>
    );
}

export default App;
